<template>
  <div class="header">
    <div class="left-side">
      <!-- <i class="bi bi-arrow-left back-button" v-if="back" @click="router.push({ name: back })"></i> -->
      <Button v-if="back" icon="bi-arrow-left" class="icon square primary" @click="router.push({ name: back })"></Button>
      <h2 class="row-text">
        {{ name }}
      </h2>
      <Button v-if="!isPublicInvitationPending && !!publicInvitation" v-tooltip="$t('app.campaign.header.copyButton.tooltip')" icon="bi-link-45deg" class="square sm outline black primary-hover" @click="copyLink"></Button>
    </div>
    <div class="right-side" v-if="buttons">
      <template v-for="(btn, index) in props.buttons" :key="index">
        <div v-if="btn.routeParams && !btn.disabled" class="button-wrapper">
          <router-link
            class="btn"
            :class="btn.class"
            :data-step="btn.step || null"
            :to="btn.routeParams"
          >
            <span v-text="btn.label" />
            <i v-if="btn.icon" :class="btn.icon" />
          </router-link>
        </div>
        <Button
          v-else
          :class="btn.class"
          :label="btn.label"
          :icon="btn.icon"
          :disabled="btn.disabled"
          @click="btn.click()"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row-text {
  max-width: 800px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap
}

.left-side {
  display: flex;
  flex-direction: row !important;
  gap: 12px !important;
  align-items: center !important;
  justify-content: baseline !important;

  .back-button {
    margin-top: 4px;

    &:hover {
      color: var(--primary-color);
    }
  }
}
</style>

<script setup lang="ts">
import { reactive } from "vue";
import { copyToClipboard } from "@/composables/utils.js";
import { useCampaignPublicInvitation } from "@/queries/invitation.query";
import { useToast } from "vue-toastification";
import Button from "./global/Button.vue";

const router = useRouter();
const toast = useToast();
const { t } = useI18n();
const { data: publicInvitation, isPending: isPublicInvitationPending } = useCampaignPublicInvitation();
const { data: campaign, isPending: isCampaignPending } = useCampaignPublicInvitation();

const state = reactive({
  copied: false,
});

function copy() {
  copyToClipboard(props.shareLink, false);
  state.copied = true;
  setTimeout(() => {
    state.copied = false;
  }, 2500);
}

const campaignShareLink = computed(() => {
  if (isCampaignPending.value || !campaign.value || isPublicInvitationPending.value || !publicInvitation.value?.id)
    return null;

  return `${window.location.host.replace("app", "game")}/join?invitation_id=${
    publicInvitation.value.id
  }`;
});

async function copyLink() {
  try {
    await navigator.clipboard.writeText(campaignShareLink.value);
    toast.success(t('app.campaign.header.copyButton.successToast'));
  } catch (err) {
    toast.error(t('app.campaign.header.copyButton.errorToast'));
    console.error('Failed to copy:', err);
  }
}

const props = defineProps({
  name: {
    type: String,
  },
  shareLink: {
    type: String,
  },
  isPublic: {
    type: [String, null],
  },
  buttons: {
    type: Array,
  },
  back: {
    type: String,
    default: null,
  },
});
</script>
